// @flow
export { createDuck } from './createDuck';
export type {
  ActionCreator,
  EffectCreator,
  SelectorCreator,
  DuckOptions,
  DuckActions,
  DuckEffects,
  DuckSelectors,
  ActionTypes,
  EffectTypes,
  SelectorTypes,
  Duck,
} from './types';



// WEBPACK FOOTER //
// ../react-lib/src/lib/redux-duck/index.js